document.addEventListener("DOMContentLoaded", () => {

    const section = document.querySelector(".timeline-section");
    if (!section) return; // Avbryt om sektionen inte finns

    const wrapper = section.querySelector(".timeline-wrapper");
    if (!wrapper) return;

    const track = wrapper.querySelector(".timeline-track");
    if (!track) return;

    const items = track.querySelectorAll(".timeline-item");
    const line = track.querySelector(".time-line-line");
    if (!line) return;

    const headerHeight = 104;
    const gap = 80;

    let cleanup = null; // används för att rensa eventlyssnare vid resize

    const initTimeline = () => {
        // Ta bort tidigare listeners om de finns
        if (cleanup) cleanup();

        const isLargeScreen = window.innerWidth > 1024;
        const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const isShortViewport = window.innerHeight <= 900;

        const wrapperWidth = wrapper.clientWidth;
        const windowHeight = window.innerHeight;

        // ---- Dynamiska värden ----
        let itemWidth = 410;
        let itemHeight = 800;

        // Ändra om bred och låg viewport
        if (isLargeScreen && isShortViewport) {
            itemWidth = 620;
            itemHeight = 600;
        }

        // ---- Beräkningar ----
        const trackWidth = (itemWidth + gap) * items.length - gap;
        const horizontalScrollDistance = trackWidth - wrapperWidth;

        // ---- Sätt linjens bredd alltid ----
        line.style.width = `${trackWidth}px`;

        // ---- Sätt wrapperhöjd bara på desktop utan touch ----
        if (isLargeScreen && !hasTouch) {
            const wrapperHeight = windowHeight + horizontalScrollDistance - (windowHeight - itemHeight);
            wrapper.style.height = `${wrapperHeight}px`;
        } else {
            wrapper.style.height = "auto";
        }

        // ---- Desktop-läge ----
        if (isLargeScreen && !hasTouch) {
            let currentOffset = 0;
            let targetOffset = 0;
            let isDown = false;
            let startX = 0;
            let startScrollY = 0;
            const dragSpeed = 2.5;

            wrapper.classList.add("cursor-grab");

            const updateTrack = (offset) => {
                track.style.transform = `translateX(-${offset}px)`;
            };

            const animateTrack = () => {
                currentOffset += (targetOffset - currentOffset) * 0.2;
                updateTrack(currentOffset);
                requestAnimationFrame(animateTrack);
            };
            animateTrack();

            const startDrag = (x) => {
                isDown = true;
                startX = x;
                startScrollY = window.scrollY;
                wrapper.classList.add("cursor-grabbing", "select-none");
                wrapper.classList.remove("cursor-grab");
            };

            const dragMove = (x, isTouch = false) => {
                if (!isDown) return;
                const dx = x - startX;
                const stickyStart = section.offsetTop - headerHeight;
                const stickyEnd = stickyStart + horizontalScrollDistance;
                const maxScroll = stickyEnd - stickyStart;
                const sensitivity = isTouch ? 3.0 : dragSpeed;
                let newScrollY = startScrollY - (dx / wrapperWidth) * maxScroll * sensitivity;
                newScrollY = Math.max(stickyStart, Math.min(stickyEnd, newScrollY));
                window.scrollTo({ top: newScrollY });
            };

            const endDrag = () => {
                isDown = false;
                wrapper.classList.remove("cursor-grabbing", "select-none");
                wrapper.classList.add("cursor-grab");
            };

            // ---- Event listeners ----
            const mouseDown = (e) => { startDrag(e.pageX); e.preventDefault(); };
            const mouseMove = (e) => dragMove(e.pageX);
            const mouseUp = endDrag;
            const mouseLeave = endDrag;
            const touchStart = (e) => { startDrag(e.touches[0].pageX); e.preventDefault(); };
            const touchMove = (e) => { dragMove(e.touches[0].pageX, true); e.preventDefault(); };
            const touchEnd = endDrag;

            wrapper.addEventListener("mousedown", mouseDown);
            wrapper.addEventListener("mousemove", mouseMove);
            wrapper.addEventListener("mouseup", mouseUp);
            wrapper.addEventListener("mouseleave", mouseLeave);
            wrapper.addEventListener("touchstart", touchStart);
            wrapper.addEventListener("touchmove", touchMove);
            wrapper.addEventListener("touchend", touchEnd);

            const scrollHandler = () => {
                const scrollY = window.scrollY;
                const stickyStart = section.offsetTop - headerHeight;
                const stickyEnd = stickyStart + horizontalScrollDistance;

                if (scrollY < stickyStart) {
                    track.style.position = "relative";
                    track.style.top = "auto";
                    targetOffset = 0;
                } else if (scrollY >= stickyStart && scrollY <= stickyEnd) {
                    track.style.position = "fixed";
                    track.style.top = `${headerHeight}px`;
                    const progress = (scrollY - stickyStart) / (stickyEnd - stickyStart);
                    targetOffset = progress * horizontalScrollDistance;
                } else {
                    track.style.position = "absolute";
                    track.style.top = `${horizontalScrollDistance}px`;
                    targetOffset = horizontalScrollDistance;
                }
            };

            window.addEventListener("scroll", scrollHandler);

            // ---- Cleanup funktion ----
            cleanup = () => {
                wrapper.removeEventListener("mousedown", mouseDown);
                wrapper.removeEventListener("mousemove", mouseMove);
                wrapper.removeEventListener("mouseup", mouseUp);
                wrapper.removeEventListener("mouseleave", mouseLeave);
                wrapper.removeEventListener("touchstart", touchStart);
                wrapper.removeEventListener("touchmove", touchMove);
                wrapper.removeEventListener("touchend", touchEnd);
                window.removeEventListener("scroll", scrollHandler);
            };

        } else {
            // ---- Mobil / touch fallback ----
            section.style.overflowX = "auto";
            section.classList.add("hidden-scrollbar");

            cleanup = () => {}; // tom cleanup
        }
    };

    // Initiera direkt
    initTimeline();

    // Initiera igen vid resize
    window.addEventListener("resize", () => {
        initTimeline();
    });
});

//# sourceMappingURL=scroll-controls.js.map
